import React from "react"

import FieldProto_FormElement from "../../../../proto/render/form-element"
import FieldProjects from "../projects"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"

// const debug = "FieldProjects_FormElement"
const debug = false

export default class FieldProjects_FormElement extends FieldProto_FormElement {

    render() {
        const field = this.props.field as FieldProjects

        const unselectLabel = field.noValueOption ? field.noValueOptionLabel || undefined : undefined
        const unselectIcon = field.noValueOption ? field.noValueOptionIcon || undefined : undefined

        debug && console.log(debug, 'render', this.value, this.props)

        return <SelectParentsNew className              = {this.props.className}
                                 renderType             = {SelectParent_RenderType.FORM}
                                 placeholder            = {field.placeholder}
                                 unselectLabel          = {unselectLabel}
                                 unselectIcon           = {unselectIcon}
                                 parentsFor             = {field.parentsFor}
                                 displayWorkspaceRoot   = {field.displayWorkspaceRoot}
                                 projectIds             = {this.value}
                                 disabled               = {this.props.disabled}
                                 onChange               = {this.onChange}/>

        /*return <SelectParent className          = {this.props.className}
                             renderValue        = "form"
                             parentsFor         = {parentsFor}
                             viewMode           = {viewMode}
                             multiselect        = {true}
                             placeholder        = {field.placeholder}
                             unselectLabel      = {unselectLabel}
                             companies          = {[gd.companyId]}
                             values             = {this.value ? {projects:this.value} : null}
                             showProjectIcon    = {true}
                             showIcon           = {true}
                             searchable         = {true}
                             disabled           = {this.props.disabled}
                             onChange           = {(data:any) => {this.onChange(data ? data.projects : null)}}/>*/
    }

}